module.exports = __webpack_public_path__ + "img/audio3.0af9cae9.png";